<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
            class="box"
    >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
            <a-form-model-item
                    ref="a_ksh_control_category_ids"
                    label="分类"
                    prop="a_ksh_control_category_ids"
                    :help="formErr.a_ksh_control_category_ids"
                    :validateStatus='!formErr.a_ksh_control_category_ids||formErr.a_ksh_control_category_ids==""?"":"error"'
            >
<!--              {{form.a_ksh_control_category_ids}}-->
              <a-cascader v-model="form.a_ksh_control_category_ids" :options="category_list" change-on-select :fieldNames="fieldNames" allowClear placeholder="" />
            </a-form-model-item>
          <a-form-model-item
              ref="name"
              label="控件名称"
              prop="name"
              :help="formErr.name"
              :validateStatus='!formErr.name||formErr.name==""?"":"error"'
          >
            <a-input :maxLength=50
                     v-model="form.name"
                     @change="(e) => { formErr.name=''}"
                     @blur="(e) => {  form.name = e.target.value.trim(); }"
            />
          </a-form-model-item>
<!--            <a-form-model-item-->
<!--                    ref="option"-->
<!--                    label="配置文件"-->
<!--                    prop="option"-->
<!--                    :help="formErr.option"-->
<!--                    :validateStatus='!formErr.option||formErr.option==""?"":"error"'-->
<!--            >-->
<!--                <a-textarea  :rows="4" v-model="form.option"-->
<!--                              @change="(e) => { formErr.option=''}"-->
<!--                              @blur="(e) => {  form.option = e.target.value.trim() }"/>-->
<!--            </a-form-model-item>-->



            <a-form-model-item
                    ref="picture"
                    label="默认图片"
                    prop="picture"
                    :extra="formErr.picture"
                    :validateStatus='!formErr.picture||formErr.picture==""?"":"error"'
            >
                <a-upload
                        :action="this.$store.state.urlChang"
                        :data="{type:3}"
                        :file-list="fileList"
                        :headers="headers"
                        @change="(file)=>{handleChange(file,1)}"
                        :before-upload="beforeUpload"
                        @preview="handlePreview"
                        list-type="picture-card"
                        name="file"
                >
                    <div v-if="fileList.length < 1">
                        <a-icon type="plus"/>
                        <div class="ant-upload-text">Upload</div>
                    </div>
                </a-upload>
                <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">
                    <img :src="previewImage" alt="example" style="width: 100%"/>
                </a-modal>
            </a-form-model-item>

            <a-form-model-item
                    ref="hover_picture"
                    label="划过图片"
                    prop="hover_picture"
                    :extra="formErr.hover_picture"
                    :validateStatus='!formErr.hover_picture||formErr.hover_picture==""?"":"error"'
            >
                <a-upload
                        :action="this.$store.state.urlChang"
                        :data="{type:3}"
                        :file-list="fileListSmall"
                        :headers="headers"
                        @change="(file)=>{handleChange(file,2)}"
                        :before-upload="beforeUpload"
                        @preview="handlePreview"
                        list-type="picture-card"
                        name="file"
                >
                    <div v-if="fileListSmall.length < 1">
                        <a-icon type="plus"/>
                        <div class="ant-upload-text">Upload</div>
                    </div>
                </a-upload>
                <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">
                    <img :src="previewImage" alt="example" style="width: 100%"/>
                </a-modal>
            </a-form-model-item>

          <a-form-model-item
              ref="status"
              label="状态"
              prop="status"
              :extra="formErr.status"
              :validateStatus='!formErr.status||formErr.status==""?"":"error"'
          >
            <a-radio-group v-model="form.status"  >
              <a-radio :value="item.id" :key="item.id" v-for="(item,index) in status_list"> {{item.name}}  </a-radio>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item
              ref="user_display"
              label="用户展示"
              prop="user_display"
              :extra="formErr.user_display"
              :validateStatus='!formErr.user_display||formErr.user_display==""?"":"error"'
          >
            <a-radio-group v-model="form.user_display"  >
              <a-radio :value="item.id" :key="item.id"  v-for="(item,index) in user_display_list"> {{item.name}} </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item
              ref="abstract"
              label="介绍"
              prop="abstract"
              :help="formErr.abstract"
              :validateStatus='!formErr.abstract||formErr.abstract==""?"":"error"'
          >
            <a-input
                     type="textarea"
                     v-model="form.abstract"
                     @change="(e) => { formErr.abstract=''}"
                     @blur="(e) => {  form.abstract = e.target.value.trim(); }"
            />
          </a-form-model-item>

        </a-form-model>
        <div class="drawer-btn"  >
            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
                取消
            </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator,beforeUpload} from "../../../../utils/utils"
    import API from "../api";
    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    export default {
        name: "templateForm",
        props: ["visible","title","editId"],
        data() {
            return {fieldNames: {label: 'name', value: 'id', children: 'children'},
                drawerConfig ,
              category_list:[],
              user_display_list:[],
              status_list:[],
                fileList:[],
                fileListSmall:[],
                previewVisible: false,
                previewImage: "",
                headers: {Authorization: window.sessionStorage.getItem("signature")},
                form: {
                  a_ksh_control_category_ids:"",
                  name:'',
                  option:'',
                  picture:'',
                  hover_picture:"",
                  user_display:1,
                  status:1,
                  abstract:''
                },
                formErr: {
                  a_ksh_control_category_ids:"",
                  name:'',
                  option:'',
                  picture:'',
                  hover_picture:"",
                  user_display:'',
                  status:'',
                  abstract:''
                },
            // {required: true, message: "请输入首页内容", trigger: "blur"},{ whitespace: true, message: "请输入首页内容 " },
            rules: {
              a_ksh_control_category_ids: [{required: true, message: "请选择分类" } ,{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.a_ksh_control_category_ids)}  , trigger: "blur"  },],
              name: [{required: true, message: "请输入控件名称" } ,{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.name)}  , trigger: "blur"  },],
              // option:[{required: true, message: "请输入配置文件", },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.option)}  , trigger: "blur"  },],
              picture:[{required: true, message: " ",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.picture)}  , trigger: 'false'  },],

            },
                layout: {
                    labelCol: { span:6},
                    wrapperCol: { span: 14 },
                },
            };



        },
        watch:{visible: function (a, b) {
            if(a){
              API.service.ADD_DATA(a).then(res => {
                this.category_list=res.data.data.category_list
                this.status_list=res.data.data.status_list
                this.user_display_list=res.data.data.user_display_list
                this.form.id = ''
              })
            }

          },
            editId: function (a, b) {
                if (a != null) {
                  // this.form.id=a

                    API.service.EDIT_DATA(a).then(res => {
                        this.form = res.data.data.info
                        if (this.form.picture == "") {
                            this.fileList = []
                        } else {
                            this.fileList = [
                                {uid: this.form.picture,
                                 name: this.form.picture,
                                 status: "done",
                                 url: this.form.picture ? this.form.picture : ""
                                }
                            ]
                        }

                        if (this.form.hover_picture == "") {
                            this.fileListSmall = []
                        } else {
                            this.fileListSmall = [
                                {uid: this.form.hover_picture,
                                    name: this.form.hover_picture,
                                    status: "done",
                                    url: this.form.hover_picture ? this.form.hover_picture : ""
                                }
                            ]
                        }
                       // this.form.id=res.data.data.info.id
                    })
                } else {
                }
            }
        },
        mounted(){
            this.getFormData()
            this.getList()
        },
        methods: {
          getList() {
            API.service.ADD_DATA(a).then(res => {

              this.category_list = res.data.data.category_list
              this.status_list = res.data.data.status_list
              this.user_display_list = res.data.data.user_display_list
              this.form.id = ''
            })
          },
            getFormData(){
                API.service.ADD_DATA().then(res => {
                    this.seleList=res.data.data
                })
            },
            handleCancel() {
                this.previewVisible = false;
            },
            handleChange(info ,type) {
                // alert(type)
                let {fileList} = info;
                const status = info.file.status;
                if (status !== 'uploading') {
                    type==1?this.fileList=[]:this.fileListSmall=[]
                }
                if (status === 'done') {
                    type==1?this.fileList=fileList:this.fileListSmall=fileList
                    // this.fileList= fileList
                } else if (status === 'error') {
                }
                if (status === 'uploading') {
                    type==1?this.fileList=fileList:this.fileListSmall=fileList
                    // this.fileList= fileList
                }
                if (status=== 'done') {
                    getBase64(info.file.originFileObj, imageUrl => {
                        // this.formErr.thumb=""
                        // this.fileList= fileList
                    });
                    if(type==1){
                        this.formErr.picture=""
                    }else {
                        this.formErr.hover_picture=""
                    }
                    type==1?this.fileList=fileList:this.fileListSmall=fileList
                }
                //重新设置state
                // this.setState( {fileList});
            },
            beforeUpload(file) {
                return beforeUpload(file,2)
            },
            async handlePreview(file) {
                if (!file.url && !file.preview) {
                    file.preview = await getBase64(file.originFileObj);
                }
                this.previewImage = file.url || file.preview;
                this.previewVisible = true;
            },
            onClose() {
                this.$emit("changVisible", false);
                this.fileList=[]
                this.fileListSmall=[],
                this.formErr={
                  a_ksh_control_category_ids:"",
                  name:'',
                  option:'',
                  picture:'',
                  hover_picture:"",
                  user_display:'',
                  status:'',
                }

                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;

                if (this.fileList.length < 1) {
                    _this.formErr.picture = "请选择默认图片";
                    return;
                } else {
                    _this.formErr.picture = "";
                    this.form.picture = this.fileList[0].url
                }

                if (this.fileList.length > 0 && this.fileList[0].url) {
                    this.form.picture = this.fileList[0].url
                } else if (this.fileList.length > 0 && this.fileList[0].response) {
                    this.form.picture = this.fileList[0].response.data.url
                } else {
                    this.form.picture = ""
                }


              if (this.fileListSmall.length < 1) {
              } else {
                _this.formErr.hover_picture = "";
                _this.form.hover_picture = this.fileListSmall[0].url
              }
              if (this.fileListSmall.length > 0 && this.fileListSmall[0].url) {
                this.form.hover_picture = this.fileListSmall[0].url
              } else if (this.fileListSmall.length > 0 && this.fileListSmall[0].response) {
                this.form.hover_picture = this.fileListSmall[0].response.data.url
              } else {
                this.form.hover_picture = ""
                // return
              }
              _this.$refs.ruleForm.clearValidate('picture');


                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        this.form.id ? url =API.service.SUBMIT_EDIT : url = API.service.SUBMIT_ADD

                      submitForm(url, _this.form).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        console.log('error submit!!',valid);
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
.ant-input-number{width: 100%!important;}
.box >>> .ant-form-extra{top:calc(100% - 35px) !important;position: absolute}
.box >>> .ant-form-item-control-wrapper{position: relative}
.box >>> .ant-checkbox-wrapper + .ant-checkbox-wrapper{margin-left: 0}
/*.box >>> .ant-form-extra*/
</style>
